import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { theme } from "../styles/theme";
import Container from "../styles/Container";
import { StaticImage } from "gatsby-plugin-image";

const StyledNav = styled.nav`
  display: none;
  @media ${theme.devices.md} {
    display: block;
  }
  margin: 1.5rem;
  ul {
    margin: 0;
    padding: 0;
    text-align: center;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    font-weight: ;
  }
`;

const NavLink = styled(Link)`
  text-decoration: none;
  font-weight: 400;
  color: var(--blue);
`;
export default function Nav() {
  return (
    <StyledNav>
      <Container>
        <ul>
          <li>
            <NavLink to="/">
              <StaticImage src="../assets/images/icon.png" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/">Gallery</NavLink>
          </li>
          <li>
            <NavLink to="/pricing">Pricing</NavLink>
          </li>

          <li>
            <NavLink to="/">About Us</NavLink>
          </li>
          <li>
            <NavLink to="/appointment">Book Now!</NavLink>
          </li>
        </ul>
      </Container>
    </StyledNav>
  );
}
